'use client';

import { FC, useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

import { productDetailPayloadToBaseCarData } from '@/data/ProductApi/ProductDetailPayloadToBaseCarData';
import { addSkuToRecentlyViewed } from '@/general/helpers/recentlyViewedCookie';
import { cartStore } from '@/stores/cartStore';
import { pdpStore } from '@/stores/pdpStore';
import { ProductDetailsPayload } from '@/types/ProductDetail.type';
import { pushToDataLayer } from '@/utils/pushToDataLayer';
import { carDataToDataLayerItem } from '@/utils/pushToDataLayerProductCard';

type Props = {
  productDetails: ProductDetailsPayload;
};

export const PdpManager: FC<Props> = ({ productDetails }) => {
  const [displayedCarSwitch, setDisplayedCarSwitch] = useState<boolean>(false);
  const { setCurrentModal } = pdpStore(
    ({ setCurrentModal }) => ({
      setCurrentModal,
    }),
    shallow,
  );
  const { carLoading, carData, cartExpired } = cartStore(
    (state) => ({
      carLoading: state.carLoading,
      carData: state.carData,
      cartExpired: state.cartExpired,
    }),
    shallow,
  );

  useEffect(() => {
    sendGtmEvents(productDetails);
    addSkuToRecentlyViewed(productDetails.sku);
  }, [productDetails]);

  useEffect(() => {
    let showCartCarSwitch = false;
    if (globalThis.window !== undefined) {
      showCartCarSwitch = new URLSearchParams(window.location.search).get('action') === 'switchCart';
    }

    const result = showCartCarSwitch && !carLoading && !!carData && !cartExpired;
    if (result && !displayedCarSwitch) {
      setCurrentModal({ name: 'carSwitch' });
      setDisplayedCarSwitch(true);
    }
  }, [carLoading, carData, cartExpired, displayedCarSwitch]);

  return null;
};

const sendGtmEvents = (productDetails: ProductDetailsPayload) => {
  pushToDataLayer({ event: 'ecommerce_clear', ecommerce: null });
  pushToDataLayer({
    event: 'view_item',
    ecommerce: {
      items: [carDataToDataLayerItem(productDetailPayloadToBaseCarData(productDetails))],
    },
  });
};
